angular
    .module("skillBuilderSaaS")
    .factory("stateModalService", ["$uibModal", "$state", "$timeout", function ($uibModal, $state, $timeout) {
        var stateModalServiceFactory = {};
        stateModalServiceFactory.openStateModal = function (templateUrl, controller, size) {
            ;
            var goToParent = true;
            var reload = false;
            var modalOptions = {
                templateUrl: templateUrl,
                ariaLabelledBy: "modal-title",
                size: "",
                controller: null
            };
            if (!size)
                size = "md";
            modalOptions.size = size;
            if (controller)
                modalOptions.controller = controller;
            //need timeout to correct params
            $timeout(function () {
                $uibModal.open(modalOptions).result.then(function () { }, function (reason) {
                    goToParent = reason !== "stateChange";
                    reload = reason === "reload";
                }).finally(function () {
                    if (goToParent) {
                        var options = { location: "replace", reload: false };
                        if (reload)
                            options.reload = true;
                        $state.go("^", $state.params, options);
                    }
                });
            }, 10);
        };
        stateModalServiceFactory.openComponent = function (component, size) {
            ;
            var goToParent = true;
            var reload = false;
            if (!size)
                size = "md";
            var modalOptions = {
                component: component,
                ariaLabelledBy: "modal-title",
                size: size
            };
            //need timeout to correct params
            $timeout(function () {
                $uibModal.open(modalOptions).result.then(function () { }, function (reason) {
                    goToParent = reason !== "stateChange";
                    reload = reason === "reload";
                }).finally(function () {
                    if (goToParent) {
                        var options = { location: "replace", reload: false };
                        if (reload)
                            options.reload = true;
                        $state.go("^", $state.params, options);
                    }
                });
            }, 10);
        };
        return stateModalServiceFactory;
    }]);
